import $, { Event } from 'jquery';

export default class Nav {
  constructor() {
    this.subMenuTrigger = $('.menu--offcanvas .menu__item.has-children > .menu__link');
    this.showMoreLink = $('.show-more-link, .show-less-link');
    this.scrollTo = $('.scroll-to a, a.scroll-to');
  }

  init() {
    this.subMenuTrigger.on('click', (event) => this.toggleSubNav(event));
    this.showMoreLink.on('click', (event) => this.showMoreContent(event));
    $(window).on('load', () => this.smoothScroll());
    $(window).on('load', () => this.bindModals());

    $(window).on('keyup', (ev) => {
      if (ev.originalEvent.key == 'Escape') {
        this.closeAllModals();
      }
    });
  }

  closeAllModals() {
    $('.senior-ticket-form').removeClass('is-active');
    $('#overlay-mask').removeClass('is-active');
  }

  bindModals() {
    $('.button--modal-open').on('click', function(e) {
      e.preventDefault();
      let id = $(this).data('modal-id');
      $('#modal-' + id).addClass('is-active');
      $('#overlay-mask').addClass('is-active');
    });

    $('.close-modal').on('click', function(e) {
      e.preventDefault();
      let id = $(this).data('modal-id');
      $('#modal-' + id).removeClass('is-active');
      $('#overlay-mask').removeClass('is-active');
    });
  }

  smoothScroll() {
    if (this.scrollTo.length > 0) {
      let scrollTo = new Foundation.SmoothScroll($('.scroll-to a, a.scroll-to'), {
        animationDuration: 800,
        animationEasing: 'swing',
        offset: 80,
      });
    }
  }

  showMoreContent(event) {
    event.preventDefault();
    $('.show-more-content').toggle();
    $('.show-more-link').toggleClass('show-more-link--clicked');
  }

  toggleSubNav(event) {
    event.preventDefault();

    let menuItem = event.currentTarget;

    if (event.offsetX > $(menuItem).outerWidth() - 40) {
      //trigger sub nav
      $(menuItem)
        .parent()
        .find('.sub-menu')
        .slideToggle(300);
      $(menuItem)
        .parent()
        .toggleClass('is-open');
    } else {
      //follow link
      location.href = $(menuItem).attr('href');
    }
  }
}
